import React, { useEffect, useState } from 'react'
import { AiOutlinePlusCircle, AiOutlineDelete, AiOutlineEdit } from 'react-icons/ai';
import Select from 'react-select';
import { useNavigate } from 'react-router-dom';
import { IoArrowBack } from "react-icons/io5";
import axios from 'axios';
import logo from '../../../../assets/logo.png'
import ToastNotification from '../../../../components/ToastNotification';
import { useLoading } from '../../../../context/LoadingContext';
import ConfirmDialog from '../../../../components/ConfirmDialog';


const CodeConduct = () => {

    const navigate = useNavigate();
    const { setLoading } = useLoading();
    // ====================useStates=========================
    const [selectedPrint, setSelectedPrint] = useState(null);
    const [editingId, setEditingId] = useState(null);
    const [isEditing, setIsEditing] = useState(false);
    const [codeConductList, setCodeConductList] = useState([]);
    const [showForm, setShowForm] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    const [employeeList, setEmployeeList] = useState([]);
    const [toast, setToast] = useState({
        show: false,
        message: '',
        bg: 'success'
    });
    const [confirmDialog, setConfirmDialog] = useState({
        show: false,
        title: '',
        message: '',
        onConfirm: null,
    });
    const getTodayDate = () => {
        const today = new Date();
        return today.toISOString().split('T')[0];
    }
    const [formData, setFormData] = useState({
        emp_db_id: '',
        from_date: getTodayDate(),
        doc_type: 'Code of Conduct',
        prefix: 'HR',
        sufix: 'COC'
    })

    // =================handlers=======================
    const showToast = (message, bg = 'success') => {
        setToast({ show: true, message, bg });
    };
    const showConfirmDialog = ({ title, message, onConfirm }) => {
        setConfirmDialog({
            show: true,
            title,
            message,
            onConfirm: () => {
                onConfirm();
                setConfirmDialog({ ...confirmDialog, show: false });
            },
        });
    };


    const filteredData = codeConductList.filter(itm =>
        Object.values(itm).some(val =>
            String(val).toLowerCase().includes(searchTerm.toLowerCase())
        )
    )

    const handleFormOpen = () => {
        setShowForm(true);
    }

    const resetForm = () => {
        setFormData({
            emp_db_id: '',
            from_date: getTodayDate(),
            doc_type: 'Code of Conduct',
            prefix: 'HR',
            sufix: 'COC'
        })
        setShowForm(false);
        setIsEditing(false);
        setEditingId(null);
    }

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            if (isEditing) {

                const res = await axios.put(`https://api.skyguard.group/api/update-hrms-documents/${editingId}`, formData);
                // console.log("Server response", res.data.message);
                showToast('Code of Conduct Updated Successfully', 'success');

                setCodeConductList(prev =>
                    prev.map(itm => itm.id === editingId ? { id: editingId, ...formData } : itm)
                );

            } else {
                const res = await axios.post('https://api.skyguard.group/api/add-hrms-documents', formData);

                showToast('Code of Conduct added successfully', 'success');
                setCodeConductList(prev => [
                    ...prev,
                    { id: res.data.insertId, ...formData }
                ]);
            }
            fetchCodeConduct();
            resetForm();

        } catch (error) {
            console.error(error);
            showToast('Error Adding Code of Conduct', 'danger');
        }
    }

    const handleChange = (e) => {
        const { name, value } = e.target;

        setFormData(prev => ({
            ...prev,
            [name]: value
        }))
    }

    const handlePrint = (row) => {
        const empFull = employeeList.find(e => e.value === row.emp_id);

        const merged = {
            ...row,
            address: empFull?.address || "",
            city: empFull?.city || "",
            state: empFull?.state || "",
            pin: empFull?.pin || "",
            emp_name: empFull?.empName || row.emp_name,
            designation: empFull?.designation || '',
            department: empFull?.department || '',
            email: empFull?.email || '',
            phone: empFull?.phone || '',
            reporting: empFull?.reporting || '',
            basic: empFull?.basic || ''
        };

        setSelectedPrint(merged);

        setTimeout(() => {
            const printContent = document.getElementById("print-area").innerHTML;
            const printWindow = window.open("", "", "width=900,height=650");
            printWindow.document.write(printContent);
            printWindow.document.close();
            printWindow.print();
        }, 300);
    };

    const handleEdit = (id) => {
        const data = codeConductList.find(item => item.id === id);

        setFormData({
            emp_db_id: data.emp_db_id || '',
            from_date: data.from_date ? data.from_date.split('T')[0] : getTodayDate(),
            doc_type: data.doc_type || 'Code of Conduct',
            prefix: data.prefix || 'HR',
            sufix: data.sufix || 'COC'
        })

        setEditingId(id);
        setIsEditing(true);
        setShowForm(true);
    }

    const handleDelete = async (id) => {
        try {
            await axios.delete(`https://api.skyguard.group/api/delete-hrms-documents/${id}`)
            showToast('Code of Conduct deleted successfully', 'success');
            fetchCodeConduct();
            setCodeConductList(prev => prev.filter(item => item.id !== id));

            if (isEditing && editingId === id) resetForm();
        } catch (error) {
            console.error('Error deleting Code of Conduct:', error);
            showToast('Failed to delete Code of Conduct', 'danger');
        }
    }

    //  ========================apis=========================

    const fetchEmployeeData = async () => {
        try {
            const res = await axios.get('https://api.skyguard.group/api/fetch-employee');
            const data = res.data.result;
            console.log(data);

            const formatted = data.map(emp => {
                const first = (emp.first || '').trim();
                const middle = (emp.middle || '').trim();
                const last = (emp.last || '').trim();

                const fullName = [first, middle, last].filter(Boolean).join(' ');
                return {
                    id: emp.id,
                    value: emp.emp_id,
                    label: `${emp.emp_id} - ${fullName}`,
                    empName: fullName,
                    address: emp.address,
                    pin: emp.pin || '',
                    state: emp.state || '',
                    city: emp.city || '',
                    designation: emp.designation || '',
                    department: emp.department || '',
                    email: emp.email || '',
                    phone: emp.phone || '',
                    reporting: emp.reporting || '',
                    basic: emp.basic || ''
                }
            });
            setEmployeeList(formatted);
        } catch (err) {
            console.error('Error fetching employee data:', err);
        }
    }

    const fetchCodeConduct = async () => {
        setLoading(true);
        try {
            const res = await axios.get('https://api.skyguard.group/api/fetch-hrms-documents?doc_type=Code of Conduct');
            setCodeConductList(res.data.result);

        } catch (error) {
            console.error("Error fetching Code of Conduct", error);
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        fetchEmployeeData();
        fetchCodeConduct();
    }, [])

    return (
        <>
            <div className='main-section'>
                <div className='container-fluid dashboard-wrapper p-3 bg-body-secondary'>
                    <button
                        onClick={() => navigate('/admin/hrms-document')}
                        className="btn btn-dark border d-flex align-items-center gap-2 px-3 py-2 shadow-sm rounded-pill mb-3"
                    >
                        <IoArrowBack size={18} /> Back
                    </button>

                    <h3 className='my-3 fw-bold fs-5 golos'>Code of Conduct</h3>

                    <div className="mb-3 row gx-3 gy-2 align-items-center d-flex justify-content-between">
                        <div className="col-12 col-md-5">
                            <input
                                type="text"
                                className="form-control border-0 border-bottom border-dark"
                                placeholder="Search..."
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                            />
                        </div>
                        <div className="col-12 col-md-2 d-flex justify-content-end">
                            <button className='btn btn-success' onClick={handleFormOpen}>
                                <AiOutlinePlusCircle size={20} /> Add
                            </button>
                        </div>
                    </div>
                    {showForm && (
                        <div className='card p-3 my-3 shadow-sm bg-white border'>
                            <form onSubmit={handleSubmit}>
                                <div className='row'>
                                    {/* left side */}
                                    <div className='col-md-6'>
                                        <div className='row g-3'>
                                            {/* Employee id */}
                                            <div className="col-12">
                                                <label className="form-label fw-medium">Select Employee </label>
                                                <Select
                                                    options={employeeList}
                                                    onChange={(selectedOption) => {
                                                        setFormData(prev => ({
                                                            ...prev,
                                                            emp_db_id: selectedOption.id,
                                                            emp_id: selectedOption.value,
                                                            emp_name: selectedOption.empName,

                                                            address: selectedOption.address,
                                                            city: selectedOption.city,
                                                            state: selectedOption.state,
                                                            pin: selectedOption.pin,
                                                            designation: selectedOption.designation,
                                                            department: selectedOption.department,
                                                            email: selectedOption.email,
                                                            phone: selectedOption.phone,
                                                            reporting: selectedOption.reporting,
                                                            basic: selectedOption.basic
                                                        }))
                                                    }}
                                                    value={
                                                        employeeList.find(opt => String(opt.id) === String(formData.emp_db_id)) || null
                                                    }
                                                    required
                                                />
                                            </div>
                                            {/* from_date   */}
                                            <div className="col-12">
                                                <label htmlFor='from_date' className="form-label fw-medium"> Date</label>
                                                <input
                                                    type="date"
                                                    className="form-control"
                                                    name="from_date"
                                                    id='from_date'
                                                    value={formData.from_date}
                                                    onChange={handleChange}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    {/* right-side */}
                                    <div className='col-md-6'>
                                        <div className='row g-3'>
                                            {/* Doc. Type */}
                                            <div className="col-12">
                                                <label htmlFor='doc_type' className="form-label fw-medium">Document Type</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    name="doc_type"
                                                    id='doc_type'
                                                    placeholder="Enter Name..."
                                                    value={formData.doc_type}
                                                    onChange={handleChange}
                                                    required
                                                    disabled
                                                />
                                            </div>
                                            {/* Prefix/Sufix */}
                                            <div className="col-12">
                                                <div className='row g-2'>
                                                    <div className='col-md-6'>
                                                        <label htmlFor='prefix' className="form-label fw-medium">Prefix</label>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            name="prefix"
                                                            id='prefix'
                                                            value={formData.prefix}
                                                            onChange={handleChange}
                                                            disabled
                                                        />
                                                    </div>
                                                    <div className='col-md-6'>
                                                        <label htmlFor='period' className="form-label fw-medium">Sufix</label>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            name="sufix"
                                                            id='sufix'
                                                            value={formData.sufix}
                                                            onChange={handleChange}
                                                            disabled
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {/* save/Cancel */}
                                <div className='d-flex justify-content-center mt-4 gap-2'>
                                    <button type='submit' className='btn btn-success'>
                                        {isEditing ? 'UPDATE' : 'SAVE'}
                                    </button>
                                    <button type='button' className='btn btn-danger'
                                        onClick={() => {
                                            resetForm();
                                        }}
                                    >
                                        Cancel
                                    </button>
                                </div>
                            </form>
                        </div>
                    )}
                    <div className='table-responsive shadow p-3 mb-5 bg-body-tertiary rounded my-4'>
                        <table className='table table-bordered table-striped text-center table-sm align-middle'>
                            <thead className='table-info'>
                                <tr>
                                    <th>SL</th>
                                    <th>Emp ID</th>
                                    <th>Emp Name</th>
                                    <th>Doc. Type</th>
                                    <th>Prefix</th>
                                    <th>Sufix</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {filteredData.length > 0 ? (
                                    filteredData.map((itm, idx) => (
                                        <tr key={idx}>
                                            <td>{idx + 1}</td>
                                            <td>{itm.emp_id}</td>
                                            <td>{itm.emp_name}</td>
                                            <td>{itm.doc_type}</td>
                                            <td>{itm.prefix}</td>
                                            <td>{itm.sufix}</td>
                                            <td>
                                                <button className='btn btn-sm btn-primary mx-1' onClick={() => handleEdit(itm.id)}><AiOutlineEdit size={18} /></button>
                                                <button className='btn btn-sm btn-danger mx-1'
                                                    onClick={() =>
                                                        showConfirmDialog({
                                                            title: 'Delete Job Confirmation',
                                                            message: `Are you sure you want to delete ${itm.emp_name} Code of Conduct ?`,
                                                            onConfirm: () => handleDelete(itm.id),
                                                        })
                                                    }
                                                >
                                                    <AiOutlineDelete size={18} />
                                                </button>
                                                <button
                                                    className='btn btn-sm btn-secondary mx-1'
                                                    onClick={() => handlePrint(itm)}
                                                >
                                                    Print
                                                </button>
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="7" className="text-center text-danger fw-bold text-muted">No data found</td>
                                    </tr>
                                )}
                            </tbody>
                            {/* ====== PRINT CODE OF CONDUCT LETTER ====== */}
                            {selectedPrint && (
                                <div id="print-area" style={{ display: "none" }}>
                                    <div
                                        style={{
                                            padding: "50px",
                                            fontFamily: "Times New Roman",
                                            lineHeight: "1.2",
                                            width: "800px",
                                            margin: "auto",
                                            background: "linear-gradient(to bottom, #f6f9ff, #eef3ff)",
                                            position: "relative",
                                        }}
                                    >
                                        {/* ====== WATERMARK COMPANY LOGO ====== */}
                                        <img
                                            src={logo}
                                            alt="watermark"
                                            style={{
                                                position: "absolute",
                                                top: "50%",
                                                left: "50%",
                                                width: "350px",
                                                height: "350px",
                                                opacity: "0.08",
                                                transform: "translate(-50%, -50%)",
                                                zIndex: "0",
                                            }}
                                        />

                                        {/* CONTENT */}
                                        <div style={{ position: "relative", zIndex: "10" }}>
                                            {/* HEADING */}
                                            <h2 style={{ textAlign: "center", marginBottom: "15px", fontSize: "22px" }}>
                                                <u>Code of Conduct</u>
                                            </h2>

                                            {/* REF + DATE */}
                                            <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "25px" }}>
                                                <p><b>Ref No:</b> {selectedPrint.prefix}/{selectedPrint.sufix}/{selectedPrint.emp_id}</p>
                                                <p><b>Date:</b> {selectedPrint.from_date}</p>
                                            </div>

                                            {/* ADDRESS BLOCK */}
                                            <p>
                                                To,<br />
                                                <b>{selectedPrint.emp_name}</b><br />

                                                {/* Address */}
                                                {selectedPrint.address && <>{selectedPrint.address}<br /></>}
                                                {(selectedPrint.city || selectedPrint.pin) && (
                                                    <>
                                                        {selectedPrint.city} {selectedPrint.pin ? `- ${selectedPrint.pin}` : ""}<br />
                                                    </>
                                                )}
                                                {selectedPrint.state && <>{selectedPrint.state}<br /></>}
                                            </p>

                                            {/* SUBJECT */}
                                            <p><b>Sub: Code of Conduct</b></p>

                                            {/* GREETING */}
                                            <p><b>Dear {selectedPrint.first},</b></p>

                                            {/* INTRO */}
                                            <p style={{ textAlign: "justify" }}>
                                                You are required to adhere to the Code of Conduct listed below. Violation of any of the
                                                guidelines will result in strict disciplinary action as decided by the management.
                                            </p>

                                            {/* SECTION: ATTIRE */}
                                            <p><b>ATTIRE:</b></p>
                                            <p style={{ textAlign: "justify" }}>
                                                1. Clean and ironed Shirt & Trouser for men and formal Western or Indian clothes for women.
                                                (No jeans, no T-shirt, no casual wear, and no bright colors & designs.)<br />
                                                2. Shirt buttons should always be fully tucked.<br />
                                                3. Shoes must be polished. (No sports shoes.)<br />
                                                4. Fresh, washed socks must be worn. No torn socks are allowed.<br />
                                                5. Men must not wear earrings, bracelets, or heavy chains. Women may wear only basic,
                                                reasonable jewelry.
                                            </p>

                                            {/* SECTION: APPEARANCE */}
                                            <p><b>APPEARANCE:</b></p>
                                            <p style={{ textAlign: "justify" }}>
                                                1. Appearance matters. You are expected to look fresh, warm, friendly, yet professional.<br />
                                                2. Men must be clean-shaven or maintain a well-groomed beard. Hair must be properly maintained.<br />
                                                3. No smoking, chewing tobacco, gutkha, or gum while on duty, whether in office or on field.<br />
                                                4. Carry a decent folder or bag and wear a watch while on duty.
                                            </p>

                                            {/* SECTION: GENERAL BEHAVIOR */}
                                            <p><b>GENERAL BEHAVIOR:</b></p>
                                            <p style={{ textAlign: "justify" }}>
                                                1. Seniors’ instructions must be followed sincerely.<br />
                                                2. No arguing or back-answering with colleagues or seniors.<br />
                                                3. You are encouraged to clarify doubts immediately. If unresolved, escalate to the Head
                                                of Department.<br />
                                                4. In case of doubt, speak to your seniors instead of gossiping among yourselves.<br />
                                                5. You are expected to report to your seniors on time — whether in the office, Command &
                                                Control premises, or on field. No excuses will be accepted.
                                            </p>

                                            <br /><br />
                                            <p>Yours Sincerely,</p>
                                            <p><b>For Star Signature Services</b></p>
                                            <br /><br />
                                            <p><b>Authorized Signatory</b></p>
                                        </div>
                                    </div>
                                </div>
                            )}

                        </table>
                    </div>
                </div >
            </div >

            <ToastNotification
                show={toast.show}
                message={toast.message}
                bg={toast.bg}
                onClose={() => setToast({ ...toast, show: false })}
            />
            <ConfirmDialog
                show={confirmDialog.show}
                title={confirmDialog.title}
                message={confirmDialog.message}
                onConfirm={confirmDialog.onConfirm}
                onCancel={() => setConfirmDialog({ ...confirmDialog, show: false })}
            />
        </>
    )
}

export default CodeConduct